"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "type", "value", "setValue", "advanced", "customValidation", "minLength", "description", "regex", "showHide", "passwordMeter", "passwordMeterStrength", "pwStrengthText", "noErrorsOrHelper"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputPassword__password_meter {\n  display: flex;\n  justify-content: space-between;\n}\n.InputPassword__password_meter__bar {\n  background-color: #d8d8d8;\n  margin: 0.5rem 0;\n  width: 24%;\n  padding: 0.125rem 0;\n  border-radius: 6px;\n}\n.InputPassword__password_meter__bar--strength_1 {\n  background-color: #c60f13;\n}\n.InputPassword__password_meter__bar--strength_2 {\n  background-color: #ffc400;\n}\n.InputPassword__password_meter__bar--strength_3 {\n  background-color: #64dd17;\n}\n.InputPassword__password_meter__bar--strength_4 {\n  background-color: #5bbc81;\n}\n.InputPassword__password_meter__text {\n  display: block;\n  font-size: 0.75rem;\n  text-align: right;\n  font-weight: 700;\n  line-height: 1rem;\n  color: #767676;\n}\n.InputPassword__password_meter__text--strength_1 {\n  color: #c60f13;\n}\n.InputPassword__password_meter__text--strength_2 {\n  color: #ff6f00;\n}\n.InputPassword__password_meter__text--strength_3 {\n  color: #4caf50;\n}\n.InputPassword__password_meter__text--strength_4 {\n  color: #008638;\n}";
  var fileName = "InputPassword_InputPassword";
  var element = document.querySelector("style[data-sass-component='InputPassword_InputPassword']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var copyPasteHandler = function copyPasteHandler(e) {
  e.preventDefault();
};
var InputPassword = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'password' : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _setValue = _ref.setValue,
    _ref$advanced = _ref.advanced,
    advanced = _ref$advanced === void 0 ? false : _ref$advanced,
    _ref$customValidation = _ref.customValidation,
    customValidation = _ref$customValidation === void 0 ? ['upper', 'lower', 'number'] : _ref$customValidation,
    _ref$minLength = _ref.minLength,
    minLength = _ref$minLength === void 0 ? 8 : _ref$minLength,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? false : _ref$description,
    _ref$regex = _ref.regex,
    regex = _ref$regex === void 0 ? {} : _ref$regex,
    _ref$showHide = _ref.showHide,
    showHide = _ref$showHide === void 0 ? false : _ref$showHide,
    _ref$passwordMeter = _ref.passwordMeter,
    passwordMeter = _ref$passwordMeter === void 0 ? false : _ref$passwordMeter,
    _ref$passwordMeterStr = _ref.passwordMeterStrength,
    passwordMeterStrength = _ref$passwordMeterStr === void 0 ? 0 : _ref$passwordMeterStr,
    _ref$pwStrengthText = _ref.pwStrengthText,
    pwStrengthText = _ref$pwStrengthText === void 0 ? ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'] : _ref$pwStrengthText,
    _ref$noErrorsOrHelper = _ref.noErrorsOrHelper,
    noErrorsOrHelper = _ref$noErrorsOrHelper === void 0 ? false : _ref$noErrorsOrHelper,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if ((0, _typeof2["default"])(regex) !== 'object' && !(regex instanceof RegExp)) {
    console.error('regex prop does not contain a regex expresion');
  }
  if (!Array.isArray(pwStrengthText)) {
    console.error('pwStrengthText must be an array.');
  } else {
    if (pwStrengthText.length < 5) {
      console.error('pwStrengthText prop has less than 5 elements.');
    }
  }
  var validation = {
    upper: customValidation.includes('upper') ? 'upper' : '',
    lower: customValidation.includes('lower') ? 'lower' : '',
    number: customValidation.includes('number') ? 'number' : ''
  };
  var buildTheMessage = function buildTheMessage() {
    var message = minLength > 0 ? "Your password must have ".concat(minLength, " or more characters") : validation.lower || validation.upper || validation.number ? 'Your password must have' : '';
    if (validation.upper || validation.lower) {
      message = "".concat(message).concat(minLength > 0 ? validation.number ? "," : ' and' : '', " ").concat(validation.upper, " ").concat(validation.upper && validation.lower ? "and " : '').concat(validation.lower, " letters");
    }
    if (validation.number) {
      message = "".concat(message).concat(minLength <= 0 ? '' : validation.lower || validation.upper ? ", and" : ' and', " at least one number");
    }
    if (regex && regex instanceof RegExp) {
      message = typeof description === 'string' ? description : '';
    }
    return "".concat(message, ".");
  };
  var isPasswordValid = function isPasswordValid(val) {
    var validateRegex = regex instanceof RegExp ? regex : new RegExp("^".concat(validation.number ? '(?=.*\\d)' : '').concat(validation.lower ? '(?=.*[a-z])' : '').concat(validation.upper ? '(?=.*[A-Z])' : '', ".{".concat(minLength, ",}$")));
    return val.match(validateRegex) !== null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
      type: !showHide ? 'password' : 'text',
      advanced: advanced,
      value: value,
      noErrorsOrHelper: passwordMeter || noErrorsOrHelper,
      className: "InputPassword ".concat(className),
      isValid: isPasswordValid,
      ref: ref,
      onCopy: copyPasteHandler,
      onPaste: copyPasteHandler,
      hideAlertIcon: true,
      setValue: function setValue(password) {
        _setValue(password);
      },
      description: description && !passwordMeter ? typeof description === 'boolean' ? buildTheMessage() : description !== '' ? description : undefined : undefined,
      showHide: showHide
    })), passwordMeter && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "InputPassword__password_meter",
        children: [0, 1, 2, 3].map(function (e, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "InputPassword__password_meter__bar ".concat(passwordMeterStrength > e ? "InputPassword__password_meter__bar--strength_".concat(passwordMeterStrength) : '')
          }, i);
        })
      }), pwStrengthText && pwStrengthText.length === 5 && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "InputPassword__password_meter__text ".concat(passwordMeterStrength > 0 ? "InputPassword__password_meter__text--strength_".concat(passwordMeterStrength) : ''),
        children: pwStrengthText[passwordMeterStrength]
      })]
    })]
  });
});
InputPassword.displayName = 'InputPassword';
var _default = InputPassword;
exports["default"] = _default;